import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import '../../styles/Auth.css';


const Unauthorized: React.FC = () => (
  <div
    style={{
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'var(--light-bg, #f5f5fa)',
      width: '100%',
    }}
  >
    <PageHeader
      title="Access Denied"
      subtitle="You do not have permission to view this page."
    />
    <div
      className="auth-container"
      style={{
        textAlign: 'center',
        marginTop: '2rem',
        background: 'rgba(255,255,255,0.9)',
        borderRadius: 12,
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
        padding: '2rem 2.5rem',
      }}
    >
      <p style={{ fontSize: '1.2rem', color: 'var(--accent-color, #9c27b0)', marginBottom: '1.5rem' }}>
        🚫 You are not authorized to access this page.
      </p>
      <Link to="/" className="primary-button">Go to Home</Link>
    </div>
  </div>
);

export default Unauthorized;
